import { useState, useMemo } from "react";

const useSortableData = (items, initialSortField = "", initialSortDirection = "asc") => {
  const [sortField, setSortField] = useState(initialSortField);
  const [sortDirection, setSortDirection] = useState(initialSortDirection);

  const sortedItems = useMemo(() => {
    if (!sortField) return items;

    return [...items].sort((a, b) => {
      const valueA = a[sortField] ?? "N/A"; // Default to "N/A" if null/undefined
      const valueB = b[sortField] ?? "N/A";

      if (typeof valueA === "number" || !isNaN(valueA)) {
        return sortDirection === "asc"
          ? parseFloat(valueA) - parseFloat(valueB)
          : parseFloat(valueB) - parseFloat(valueA);
      } else if (!isNaN(Date.parse(valueA))) {
        return sortDirection === "asc"
          ? new Date(valueA) - new Date(valueB)
          : new Date(valueB) - new Date(valueA);
      } else {
        return sortDirection === "asc"
          ? valueA.toString().localeCompare(valueB.toString())
          : valueB.toString().localeCompare(valueA.toString());
      }
    });
  }, [items, sortField, sortDirection]);

  const handleSort = (field) => {
    setSortDirection((prevDirection) =>
      sortField === field ? (prevDirection === "asc" ? "desc" : "asc") : "asc"
    );
    setSortField(field);
  };

  return { sortedItems, sortField, sortDirection, handleSort };
};

export default useSortableData;
